import { useTextDomainContext } from "@/app/providers";
import { useContext, useMemo } from "react";
import { ChipProps } from "@mui/material";

export interface StatusOption {
  value: "Active" | "InActive" | "Deleted" | "Blocked";
  label: string;
  color: ChipProps["color"];
}

export const useStatusArray = (): StatusOption[] => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  return useMemo(
    () => [
      {
        value: "Active",
        label: gettext("Active"),
        color: "success",
      },
      {
        value: "InActive",
        label: gettext("InActive"),
        color: "warning",
      },
      {
        value: "Deleted",
        label: gettext("Deleted"),
        color: "error",
      },
      {
        value: "Blocked",
        label: gettext("Blocked"),
        color: "error",
      },
    ],
    [gettext],
  );
};
